import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RegisterForm } from "../components/auth/RegisterForm";
import { useAuth } from "../hooks/useAuth";
import logo from "../../assets/logo.png";

export function RegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isInitialized } = useAuth();

  // Redirect if already authenticated
  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      const from =
        (location.state as { from?: { pathname: string } })?.from?.pathname ||
        "/app/activities";
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, isInitialized, navigate, location]);

  const handleRegisterSuccess = () => {
    const from =
      (location.state as { from?: { pathname: string } })?.from?.pathname || "/app/activities";
    navigate(from, { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-brand-500 to-brand-800 p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center mb-8">
          <img src={logo} alt="RunLens" className="h-24 mx-auto" />
        </div>

        <RegisterForm onSuccess={handleRegisterSuccess} />
      </div>
    </div>
  );
}
